/**
 * Estimates API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createCustomEstimate,
  createEstimate,
  getEstimateById,
  getEstimates,
  getEstimateVersion,
  getEstimateVersions,
  getShareableEstimate,
  getShareableEstimateHtml,
  getShareableEstimatePdf,
  renderEstimatePreview,
  updateEstimate,
} from "../generated/estimates/estimates";

import { wrapListMethod, wrapMethod } from "./utils";

export const estimates = {
  /** @see getShareableEstimate */
  getShareableEstimate: wrapMethod(getShareableEstimate),

  /** @see getShareableEstimateHtml */
  getShareableEstimateHtml: wrapMethod(getShareableEstimateHtml),

  /** @see getShareableEstimatePdf */
  getShareableEstimatePdf: wrapMethod(getShareableEstimatePdf),

  /** @see createEstimate */
  create: wrapMethod(createEstimate),

  /** @see getEstimates */
  list: wrapListMethod(getEstimates),

  /** @see createCustomEstimate */
  createCustom: wrapMethod(createCustomEstimate),

  /** @see getEstimateById */
  get: wrapMethod(getEstimateById),

  /** @see updateEstimate */
  update: wrapMethod(updateEstimate),

  /** @see getEstimateVersions */
  getVersions: wrapMethod(getEstimateVersions),

  /** @see getEstimateVersion */
  getVersion: wrapMethod(getEstimateVersion),

  /** @see renderEstimatePreview */
  renderEstimatePreview: wrapMethod(renderEstimatePreview),
} as const;

export type EstimatesApi = typeof estimates;
